// Keep the same semantic keys in every language. {name} placeholders are interpolated.
// Navigation and section labels retain their original English wording.
const sharedLabels = {
  rights: "© 2026 haesoo-y. All Rights Reserved.",
  home: "Home",
  projects: "Projects",
  experience: "Experience",
  contact: "Contact",
  work: "Work",
  education: "Education",
  contribution: "Contribution",
  workProjects: "Work Projects",
  personalProjects: "Personal Projects",
  toyProjects: "Toy Projects",
  presentation: "Presentation",
  blog: "Blog",
  community: "Community",
};
const ui = {
  ko: {
    ...sharedLabels,
    navigation: "주요 메뉴",
    language: "언어 선택",
    present: "현재",
    details: "{title} 상세 보기",
    close: "상세 모달 닫기",
    previous: "이전 이미지",
    next: "다음 이미지",
    imageError: "이미지를 불러오지 못했습니다.",
    imageLoading: "이미지를 불러오는 중입니다.",
    source: "출처",
    more: "더 보기",
    portrait: "윤해수 프로필 사진",
    notFoundTitle: "앗!",
    notFound: "찾으시는 페이지가 없습니다.",
    backHome: "홈으로 돌아가기",
  },
  en: {
    ...sharedLabels,
    navigation: "Main navigation",
    language: "Choose language",
    present: "Present",
    details: "View {title} details",
    close: "Close details",
    previous: "Previous image",
    next: "Next image",
    imageError: "Unable to load the image.",
    imageLoading: "Loading image.",
    source: "Source",
    more: "View More",
    portrait: "Portrait of Harry Yoon",
    notFoundTitle: "Oops!",
    notFound: "We can’t find the page you’re looking for.",
    backHome: "Go back to the home page",
  },
  ja: {
    ...sharedLabels,
    navigation: "メインナビゲーション",
    language: "言語を選択",
    present: "現在",
    details: "{title}の詳細を見る",
    close: "詳細を閉じる",
    previous: "前の画像",
    next: "次の画像",
    imageError: "画像を読み込めませんでした。",
    imageLoading: "画像を読み込んでいます。",
    source: "出典",
    more: "詳しく見る",
    portrait: "ユン・ヘスのプロフィール写真",
    notFoundTitle: "おっと！",
    notFound: "お探しのページが見つかりません。",
    backHome: "ホームに戻る",
  },
};
export default ui;
